export abstract class Source {
  id: string;

  constructor(id: string) {
    this.id = id;
  }

  abstract get duration(): number;
  abstract get position(): number;
  abstract play(timestamp: number, playbackRate?: number): void;
  abstract pause(): void;
  abstract seek(timestamp: number): Promise<void>;
}
